<template>
    <universal-uploader
        class="text-truncate"
        @uploadSuccess="uploadSuccess"
        :clientAllowedFormats="['image', 'video']"
    >
        <slot />
    </universal-uploader>
</template>

<script>
import { mapState } from "vuex";
import UniversalUploader from "@/components/universalUploader/UniversalUploader";

export default {
    methods: {
        async uploadSuccess(url, info) {
            this.$emit("uploadError", null);

            const type = info.resource_type === "video" ? "video" : "photo";

            await this.api
                .post("/creatorRequest/addMedia", {
                    creatorRequestId: this.creatorRequest.id,
                    type,
                    publicId: info.public_id,
                })
                .catch((error) => {
                    this.$emit("uploadError", error.response.data.message);
                });

            this.$store.dispatch("creatorRequest/refresh");
        },
    },
    computed: {
        ...mapState("creatorRequest", ["creatorRequest"]),
    },
    components: {
        UniversalUploader,
    },
};
</script>
